export default [
    {
        comment: '',
        error_id: 'T-WSEL-01',
        data: [
            {
                "cross_section": "43827",
                "target_cross_section": "43827",
                "diff": "2.01",
                "selected_yrex100_ws_elev": "154.80",
                "target_yrex100_ws_elev": "156.81"
            },
            {
                "cross_section": "43002",
                "target_cross_section": "43002",
                "diff": "-2.00",
                "selected_yrex100_ws_elev": "154.09",
                "target_yrex100_ws_elev": "152.09"
            },
            {
                "cross_section": "42210",
                "selected_yrex100_ws_elev": "153.80",
                "target_yrex100_ws_elev": "153.80",
                "diff": "0.00"
            }
        ]
    },
    {
        comment: '',
        error_id: 'T-WSEL-ICS-01',
        data: [
            {
                "cross_section": "43827 BR U",
                "target_cross_section": "43827 BR U",
                "diff": "2.01",
                "selected_yrex100_ws_elev": "154.80",
                "target_yrex100_ws_elev": "156.81"
            },
            {
                "cross_section": "43002 BR U",
                "target_cross_section": "43002 BR U",
                "diff": "-2.00",
                "selected_yrex100_ws_elev": "154.09",
                "target_yrex100_ws_elev": "152.09"
            },
            {
                "cross_section": "42210 BR D",
                "target_cross_section": "42210 BR D",
                "diff": "0.00",
                "selected_yrex100_ws_elev": "153.80",
                "target_yrex100_ws_elev": "153.80",
                
            }
        ]
    },
]